<div class="help-container p-4 card">
  <div class="header-section">
    <div class="bg-primary border-round-lg p-5 mb-5">
      <div class="flex flex-column align-items-center justify-content-center">
        <h1 class="text-0 font-bold text-5xl mb-3 text-center">Get Help</h1>
        <p class="text-0 text-xl text-center">Find answers to your questions or submit feedback</p>
      </div>
    </div>

    <div class="grid mb-5">
      <div class="col-12 md:col-4 mb-4" *ngFor="let helpItem of helpItems">
        <p-card styleClass="h-full">
          <ng-template pTemplate="header">
            <div class="flex justify-content-center pt-4">
              <span class="inline-flex align-items-center justify-content-center border-circle w-5rem h-5rem bg-primary-100 shadow-2">
                <i [class]="helpItem.icon + ' pi text-4xl text-primary-700'"></i>
              </span>
            </div>
          </ng-template>

          <div class="flex flex-column align-items-center text-center">
            <h2 class="text-2xl mb-3 font-medium">
              {{ helpItem.title }}
            </h2>
            <p class="line-height-3 mb-3">
              {{ helpItem.shortDescription }}
            </p>
          </div>

          <ng-template pTemplate="footer">
            <div class="flex justify-content-center">
              <button
                pButton
                [routerLink]="['/app/help-details', helpItem._id]"
                label="View Steps"
                icon="pi pi-arrow-right"
                iconPos="right"
                class="p-button-outlined"
              ></button>
            </div>
          </ng-template>
        </p-card>
      </div>
    </div>
  </div>
  <div class="px-6">
    <!-- <div class="text-2xl mb-3 font-medium">Frequently asked questions</div> -->
    <app-faqs-list></app-faqs-list>
  </div>
  <div class="px-6 pt-6" #feedback>
    <!-- <div class="text-2xl mb-3 font-medium">
            Do you have feedback for us?
        </div> -->
    <app-issue-feedback></app-issue-feedback>
  </div>
</div>
